module.exports = "data:image/jpeg;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWcvY29zdGFsLTMtMS5hY2UyM2MyMi5qcGciOw=="